import React, { Component } from "react";
import axios from "axios";                  // library used to send data to the server 
import "./ContactForm.css";
import Recaptcha from 'react-recaptcha';

// The contact form uses state variables to record user input and then sends it to the server via axios
// It then resets the form fields after 6 seconds

export default class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fname: '',
            email: '',
            subject: '',
            message: '',
            isCaptchaValid: false,
            CaptchaKey: '',
            acknowledgement: 'Submit',
            error: '',
            emailErr: '',
            isError: false,            
            sent: false
        }
    }

    reset = () => {
        this.setState({
            fname: '',
            email: '',
            subject: '',
            message: '',
            isCaptchaValid: false,
            CaptchaKey: '',
            acknowledgement: 'Submit',
            error: '',
            emailErr: '',
            isError: false,            
            sent: false
        })
    }

    // reCaptcha functions
    // onCaptchaLoad is a developer function to verify that Captcha is loading successfully
    // onCaptchaVerify is used to verify the user selected the Captcha and to capture the response from the API. 
    // The Captcha resets after 2 minutes

    onCaptchaLoad = () =>{        
        console.log('Captcha Loaded')
    }

    onCaptchaVerify = (response) =>{
        this.setState({
            isCaptchaValid: true,
            CaptchaKey: response
        })
    }

    // Form Validaton Function to verify 
    // required fields are not empty, 
    // email pattern is correct and 
    // reCaptcha has been selected

    handleValidation(){
        let formValid = true;

        // Validate required fields are not empty
        if(this.state.fname === '' || this.state.email === '' || this.state.message === '') {
            formValid = false;
            this.setState({
                error: 'Don\'t forget to enter your Name, Email and Message!'
            })
        }
            
        // verify email address is formed correctly
        let lastAtPos = this.state.email.lastIndexOf('@');
        let lastDotPos = this.state.email.lastIndexOf('.');

        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.email.indexOf('@@') === -1 && lastDotPos > 2 && (this.state.email.length - lastDotPos) > 2 )) {
            formValid = false;
            this.setState({
                emailErr : "Please enter a valid email address"
            })
        }

        // set error if Captcha is not selected
        if(!this.state.isCaptchaValid){
            formValid = false;
            this.setState({
                error: "Please verify reCaptcha"
            })
        }
        this.setState({isError: !formValid})
        return formValid;
    }

    // Form Submission Handler
    handleFormSubmit = (event) => {
        event.preventDefault();
                
        if(this.handleValidation()) {
            this.setState({
                acknowledgement: "Sending..."
            })
        
        axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL,                 // this variable is set in the .env file
            headers: { "content-type": "application/json" },
            data: this.state
        })
            .then(result => {
                this.setState({
                    sent: result.data.sent,
                })
                if(result.data.sent){
                    this.setState({
                        acknowledgement: "Message Sent!",
                    })
                }else{
                        this.setState({
                            acknowledgement: "Message Not Sent!",
                            error: "Your message could not go through at the moment.",
                            isError: true
                        })
                    
                }
                
                setTimeout(() => { this.reset() }, 6000)
            })
            .catch(error => {this.setState({ error: error.message }); console.log(this.state.error)});
        // this.reset();
        }
    }

    render() {
        return (
            <div className="form-page" id="contact-us">
                <div className="sub-heading">
                <h3>CONTACT US</h3>
            </div>
            <div className='container-fluid'>
                    <form action="#" className="form">
                        <div className="info">
                            <label>Name</label><label className="required">*</label><br />
                            <input type="text" id="fname" name="firstname" placeholder="Your Name.." value={this.state.fname} onChange={e => this.setState({ fname: e.target.value })} required/><br />
                            
                        </div>
                        <div className="info">
                            <label>Email</label><label className="required">*</label><span className="error required" style={{fontSize:"12px"}}>{this.state.emailErr}</span><br />
                            <input type="email" id="email" name="email" 
                            placeholder="abc@email.com" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                            value={this.state.email} onChange={e => this.setState({ email: e.target.value })} required />
                            
                        </div>
                        <div className="info">
                            <label>Subject</label><br />
                            <input type="text" id="subject" name="subject" placeholder="Subject..." value={this.state.subject} onChange={e => this.setState({ subject: e.target.value })} /><br />
                        </div>
                        <div className="info">
                            <label>Message</label><label className="required">*</label><br />
                            <textarea id="message" name="message" className="message" rows="10" maxLength="1000" multiline="true" placeholder="Write something.." value={this.state.message} onChange={e => this.setState({ message: e.target.value })} required /><br />
                            
                        </div>
                        <div>
                        <Recaptcha
                            onloadCallback={this.onCaptchaLoad}
                            sitekey={process.env.REACT_APP_SITE_KEY}        
                            render="explicit"
                            verifyCallback={this.onCaptchaVerify}
                        /> {/* the REACT_APP_SITE_KEY is set in the .env file */}
                        </div>
                        <input type="submit" value={this.state.acknowledgement} onClick={this.handleFormSubmit} className="btn_contact" /> {/* Display Message Sending Confirmation */}
                        <div>                            
                            {this.state.isError && this.state.error}  {/* Display Error Messages */}                                
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}